import { FilterCategoryDisplayName } from "@hub/data/values/data-values.enum";
import { useLabFiltering } from "@hub/services/use-lab-filtering";
import React from "react";
import { FilterCategory } from "./filter-category";
import styles from "./filters-bar.module.css";

export const LabFiltersBar: React.FC = () => {
  const {
    enabledFilterGroups,
    availableFilterOptions,
    topicFilterValues,
    handleTopicFilter,
  } = useLabFiltering();

  if (!availableFilterOptions) {
    return null;
  }

  const { topicOptions } = availableFilterOptions;

  return (
    <div className={styles.filtersBar}>
      {enabledFilterGroups && (
        <>
          {enabledFilterGroups.topic && (
            <FilterCategory
              categoryName={FilterCategoryDisplayName.Topic}
              options={topicOptions}
              selectOption={handleTopicFilter}
              filterValues={topicFilterValues}
            />
          )}
        </>
      )}
    </div>
  );
};
